
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import axios from 'axios';

@Component({})
export default class UpdateDictData extends Vue {
    /** Код справочника в API интеграции: GU, EKR, … */
    @Prop({ type: String, default: 'GU' })
    apiDictCode!: string;
    uploadLogLoading = false;
    currentPage = 0;
    pageSize = 20;
    totalPages = 0;
    totalElements = 0;
    changesData: any[] = [];
    selectedChangeIndex = 0;

    changesFields = [
        { key: 'code', label: 'code', sortable: false, fixed: true },
        { key: 'source_id', label: 'source id', sortable: false },
        { key: 'summary_flag', label: 'summary flag', sortable: false },
        { key: 'name_ru', label: 'name ru', sortable: false },
        { key: 'name_kk', label: 'name kk', sortable: false },
        { key: 'gu_bin', label: 'gu bin', sortable: false },
        { key: 'gu_rnn', label: 'gu rnn', sortable: false },
        { key: 'id_region', label: 'id region', sortable: false },
        { key: 'id_budget_type', label: 'id budget type', sortable: false },
        { key: 'beg_date', label: 'beg date', sortable: false, fixed: true },
        { key: 'end_date', label: 'end date', sortable: false },
        { key: 'kato', label: 'kato', sortable: false },
        { key: 'budget_type', label: 'budget type', sortable: false },
        { key: 'rucov', label: 'rucov', sortable: false },
        { key: 'buhgal', label: 'buhgal', sortable: false },
        { key: 'abp_owner', label: 'abp owner', sortable: false },
        { key: 'min_level', label: 'min level', sortable: false },
        { key: 'org_attribute', label: 'УО', sortable: false } ];

    tableFields = [
        { key: 'field', label: 'Поле', sortable: false },
        { key: 'value', label: 'Значение', sortable: false },
        { key: 'oldValue', label: 'Старое значение', sortable: false },
        { key: 'newValue', label: 'Новое значение', sortable: false }
    ];

    async mounted() {
        await this.loadChanges();
    }

    @Watch('apiDictCode')
    async onApiDictCodeChange() {
        this.currentPage = 0;
        await this.loadChanges();
    }

    async loadChanges() {
        this.uploadLogLoading = true;
        try {
            const response = await axios.get(`/api/integration/dict/changes/${this.apiDictCode}`, {
                params: {
                    page: this.currentPage,
                    size: this.pageSize
                }
            });

            this.changesData = response.data.content;
            this.totalPages = response.data.totalPages;
            this.totalElements = response.data.totalElements;

            if (this.changesData.length > 0) {
                this.selectedChangeIndex = 0;
            }
        } catch (error) {
            console.error('Error loading changes:', error);
        } finally {
            this.uploadLogLoading = false;
        }
    }

    get selectedChange() {
        return this.changesData[this.selectedChangeIndex] || null;
    }

    get tableItems() {
        if (!this.selectedChange) {
            return [];
        }

        const values = this.selectedChange.values || {};
        const changes = this.selectedChange.changes || {};

        return this.changesFields.map(field => {
            const isFixed = field.fixed; // code и beg_date не меняются
            const fieldKey = field.key;

            if (isFixed) {
                // Для code и beg_date показываем только значение
                let value = values[fieldKey];
                if (fieldKey === 'beg_date' && value) {
                    value = new Date(value).toLocaleDateString();
                }
                return {
                    field: field.label,
                    value: value || '-',
                    oldValue: '',
                    newValue: ''
                };
            } else {
                // Для остальных полей показываем oldValue и newValue
                const change = changes[fieldKey];
                return {
                    field: field.label,
                    value: '',
                    oldValue: change ? (change.oldValue || '-') : '-',
                    newValue: change ? (change.newValue || '-') : '-'
                };
            }
        });
    }

    selectChange(index: number) {
        this.selectedChangeIndex = index;
    }

    async nextPage() {
        if (this.currentPage < this.totalPages - 1) {
            this.currentPage++;
            await this.loadChanges();
        }
    }

    async prevPage() {
        if (this.currentPage > 0) {
            this.currentPage--;
            await this.loadChanges();
        }
    }
}
